module.exports = __webpack_public_path__ + "img/status-off.78e99635.svg";